/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_SoloInputs */

const en_platform_team_solo = /** @type {(inputs: Platform_Team_SoloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo`)
};

const pl_platform_team_solo = /** @type {(inputs: Platform_Team_SoloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sam`)
};

/**
* | output |
* | --- |
* | "Solo" |
*
* @param {Platform_Team_SoloInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_solo = /** @type {((inputs?: Platform_Team_SoloInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_SoloInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_solo(inputs)
	return en_platform_team_solo(inputs)
});